import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CampaignsFilterEntity } from '../../domain/entities/CampaignsFilterEntity'
export class CampaignsFilterModel extends CampaignsFilterEntity {
    startDate?: string
    endDate?: string
    branchId?:number
    userId?:string
    excludedBranchId?:number
    groupId?:number
    channelId?:number
    serviceId?:number

  constructor(dataDto: CampaignsFilterEntity) {
    super()
    mapEntityProperties<CampaignsFilterModel>(this, dataDto, {
      exclude: ['dateRange' ,'user', 'branch', 'excludedBranch', 'group', 'channel', 'service'],
      map: {
        startDate: dataDto.dateRange ? dataDto.dateRange[0] : undefined,
        endDate: dataDto.dateRange ? dataDto.dateRange[1] : undefined,
        branchId:dataDto.branch?.id,
        userId: dataDto.user?.id,
        excludedBranchId:dataDto.excludedBranch?.id,
        groupId:dataDto.group?.id,
        channelId:dataDto.channel?.id,
        serviceId:dataDto.service?.id,
      }
    })
  }
}
